export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/US-5b98f6f3041409dd54d4684ef14a9876.png";